import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { LegalContent } from "@/components/LegalContent";

// Two inline links ("Terms of Service" · "Privacy Policy") that open a shared,
// scrollable dialog with the full policy. Drop into the login footer and Settings.
export const LegalLinks = ({ className = "", linkClassName = "underline hover:text-zinc-100" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <span className={className}>
        <button type="button" onClick={() => setOpen(true)} className={linkClassName} data-testid="open-legal-link">Terms &amp; Privacy Policy</button>
      </span>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg border-zinc-800 bg-zinc-950" data-testid="legal-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-zinc-50">Terms &amp; Privacy</DialogTitle>
            <DialogDescription className="sr-only">Terms of Service and Privacy Policy</DialogDescription>
          </DialogHeader>
          <div className="max-h-[70vh] overflow-y-auto pr-1">
            <LegalContent />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
